import React, { lazy } from "react";

const LazyUnathorized = lazy(() => import("./Unathorized"));

const Unathorized = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyUnathorized {...props} />;

export default Unathorized;
